import React from 'react';

import { NodeState } from '../hooks/use-checkbox-states';
import classNames from 'classnames';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

export interface Props {
	onChange: (id: string, state: NodeState) => void;
	state: NodeState;
	filled: boolean;
	id: string;
	isDisabled?: boolean;
	'aria-label'?: string;
}

const StateToIcon = {
	[NodeState.full]: BringgFontIcons.Selected,
	[NodeState.partial]: BringgFontIcons.Minus,
	[NodeState.empty]: null
};
const StateToAriaChecked = {
	[NodeState.full]: true,
	[NodeState.partial]: 'mixed',
	[NodeState.empty]: false
} as const;

const Checkbox: React.FC<Props> = ({ onChange, state, filled, id, isDisabled = false, 'aria-label': ariaLabel }) => {
	const icon = StateToIcon[state];

	const onClick = () => {
		if (isDisabled) return;

		if (state === NodeState.empty) {
			onChange(id, NodeState.full);
		} else {
			onChange(id, NodeState.empty);
		}
	};

	return (
		<div
			role="checkbox"
			aria-label={ariaLabel}
			aria-checked={StateToAriaChecked[state]}
			aria-disabled={isDisabled}
			className={classNames('tree-checkbox', { filled, disabled: isDisabled })}
			onClick={onClick}
		>
			{icon && <BringgIcon iconName={icon} className="icon" />}
		</div>
	);
};

export default Checkbox;
